import { useMemo } from "react";

export default function DataTable({
  TableHead,
  TableData,

  tableRef,
  tableRowStyle = "",
  thStyle = "",
  tbodyStyle = "",
  trStyle = "",
  tdStyle = "",
  containerStyle = "",
  tableStyle = "",
}) {
  const allKeysPresent = useMemo(
    () =>
      TableHead.every((header) =>
        TableData?.every((dataItem) =>
          Object.keys(dataItem)
            .map((el) => el.toLowerCase())
            .includes(header.accessorKey.toLowerCase())
        )
      ),
    [TableHead, TableData]
  );

  if (!allKeysPresent) {
    throw new Error(
      "Table data does not contain all required accessor keys of headers or table data objects don't have the same keys. Check data and headers arrays !"
    );
  }

  return (
    <>
      <table className={` px-4 leading-normal  w-full ${tableStyle}`} ref={tableRef}>
        <thead
          className={
            "w-full border-b border-b-[#888888] text-mainGray dark:text-gray-300  whitespace-nowrap font-medium"
          }
        >
          <tr className={`${tableRowStyle}`}>
            {TableHead?.map((item, i) => (
              <th key={i} className={`px-4 py-2 min-w-[100px] ${thStyle}`}>
                {item.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={`${tbodyStyle}`}>
          {TableData?.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={`border-b border-b-[#8888885c] dark:text-gray-300 text-[#888888] ${trStyle}`}
            >
              {TableHead.map((head, colIndex) => (
                <td
                  key={colIndex}
                  className={`text-center text-mainGray dark:text-gray-300 py-2 min-w-[100px] ${tdStyle}`}
                >
                  {head.accessorKey === "image" && row[head.accessorKey] ? (
                    <div className="flex items-center justify-center ">
                      <img
                        alt="img"
                        src={row[head.accessorKey]}
                        width={50}
                        height={50}
                        className="rounded-full size-[50px] object-cover"
                      />
                    </div>
                  ) : (
                    row[head.accessorKey] ?? ""
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
